var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"indexlayout"}},[_c('div',{class:{ 'fiexd-header': _vm.siteFiexdHeader },attrs:{"id":"indexlayout-right"}},[_c('div',{staticClass:"indexlayout-right-main"},[_c('app-main')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }